import cx from 'classnames';
import { Button, Text } from 'platform-components';
import { TEXT_MARKUP_TYPE } from 'platform-components/constants';
import { copyTextToClipboard } from 'platform-components/utils';
import React from 'react';

import './afisha-banner.scss';

interface Props {
    text: string;
    className?: string;
    onCopyButtonClick: () => void;
    onClick: () => void;
}

export const AfishaBanner = ({ className, text, onClick, onCopyButtonClick }: Props) => {
    return (
        <div className={cx('afisha-banner', className)}>
            <div className="afisha-banner__text-ticket">
                <Text id="afishaBanner.header" size={Text.SIZE.XXXL} weight={Text.WEIGHT.L} />
                <div className="afisha-banner__text-block">
                    <Text
                        id="afishaBanner.text"
                        size={Text.SIZE.XL}
                        type={TEXT_MARKUP_TYPE.MARKDOWN}
                        weight={Text.WEIGHT.S}
                    />
                </div>
                <div className="afisha-banner__promo-link">
                    <div className="afisha-banner__link-window">{text}</div>
                    <Button
                        className="afisha-banner__copy-button"
                        onClick={() => {
                            copyTextToClipboard(text);
                            onClick();
                            onCopyButtonClick();
                        }}
                        size={Button.SIZE.M}
                        view={Button.VIEW.ACTION}
                    >
                        <Text id="afishaBanner.button" weight={Text.WEIGHT.M} />
                    </Button>
                </div>
            </div>
            <div className="afisha-banner__logo-ticket">
                <div className="afisha-banner__promo">
                    <Text id="afishaBanner.promo" size={Text.SIZE.XXXL} weight={Text.WEIGHT.L} />
                </div>
                <div className="afisha-banner__thousand">
                    <Text id="afishaBanner.thousand" size={Text.SIZE.XXXL} weight={Text.WEIGHT.L} />
                </div>
            </div>
        </div>
    );
};
